import { useQuery } from "@tanstack/react-query";
import { campaignKeys, fetchCampaigns } from "./campaigns-api";

export function useCampaigns(productCode: string | undefined) {
  return useQuery({
    queryKey: campaignKeys.byProduct(productCode ?? ""),
    queryFn: () => fetchCampaigns(productCode!),
    enabled: !!productCode,
  });
}
